export const showClearAlert = type => ({
    type,
});

export default (state = false, action = {}) => {
    switch(action.type) {
        case "SHOW_CLEAR_ALERT":
            return state = true;
        case "HIDE_CLEAR_ALERT":
            return state = false;
        default: return state;
    }
}




// WEBPACK FOOTER //
// ./src/state/showClearAlert.js